/**
 * 组织成员相关 API（对接 tRPC 后端 trpc.samples.deeptutor.Admin）
 */
import { http } from '@/utils';

const Api = {
    List: '/ListMembers',
    Create: '/CreateMember',
    Update: '/UpdateMember',
    Delete: '/DeleteMember',
    SaveRoles: '/SaveMemberRoles',
};

/** 分页查询成员 */
export async function listMembers(params: API.ListMembersReq): Promise<API.ListMembersRsp> {
    const response = await http.post<API.ListMembersRsp>(Api.List, params);
    return response?.Data || { Total: 0, Items: [] };
}

/** 新建成员 */
export async function createMember(params: API.CreateMemberReq): Promise<API.MemberInfo> {
    const response = await http.post<API.MemberInfo>(Api.Create, params);
    return response?.Data || {};
}

/** 更新成员 */
export async function updateMember(params: API.UpdateMemberReq): Promise<API.MemberInfo> {
    const response = await http.post<API.MemberInfo>(Api.Update, params);
    return response?.Data || {};
}

/** 删除成员（软删除） */
export async function deleteMember(params: API.DeleteMemberReq): Promise<void> {
    await http.post(Api.Delete, params);
}

/** 保存成员角色 */
export async function saveMemberRoles(params: API.MemberRolesReq): Promise<API.MemberInfo> {
    const response = await http.post<API.MemberInfo>(Api.SaveRoles, params);
    return response?.Data || {};
}
